<template>
  <div class="dialog-bg">
    <div class="skin-analysis-failed-dialog">
      <div class="skin-analysis-failed-message">{{ errorMessage }}</div>
      <button type="button" class="skin-analysis-again" @click="goToTutorial()">
        {{ $t("skinAnalysis.fail.again") }}
      </button>
    </div>
  </div>
</template>

<script>
import constant from "@/const";

export default {
  data() {
    return {
      accountId: undefined,
    };
  },
  computed: {
    errorMessage() {
      return `${this.$t("skinAnalysis.fail.errorMessage")}\n\n${this.$t(
        constant.ERROR_CODE_GUIDE
      )}\nE700-404`;
    },
  },
  mounted() {
    if (this.$route.query.accountId) {
      this.accountId = this.$route.query.accountId;
    }
  },
  updated() {},
  methods: {
    goToTutorial() {
      this.$router.replace({
        name: "TutorialView",
        query: { accountId: this.$route.query.accountId },
      });
    },
  },
};
</script>

<style>
.dialog-bg {
  width: 100vw;
  min-height: 100svh;
  position: fixed; /* ブラウザの定位置に固定 */
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.skin-analysis-failed-dialog {
  height: 300px;
  width: 80%;
  position: relative;
  background: white;
  border-radius: 18px;
}

.skin-analysis-failed-message {
  position: absolute;
  top: 32px;
  left: 20px;
  right: 20px;
  transform: translate(0%, 0%);
  white-space: pre-wrap;
  text-align: left;
}
.skin-analysis-again {
  width: 158px;
  height: 52px;
  position: absolute;
  bottom: 22px;
  left: 50%;
  transform: translate(-50%, 0%);

  display: block;
  font-size: 14px;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 影を追加 */
  background: #000000 0% 0% no-repeat padding-box;
  border-radius: 26px;
  opacity: 0.9;
  color: #fff;
  text-decoration: none;
  text-align: center;
}
</style>
